import Record from "./base"

export default class Instructor extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
